import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appModal]'
})
export class ModalDirective {

  constructor() { }

  @HostListener('click') modalOpen(){
    document.getElementById('myModal').classList.toggle('d-block');
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/modal.directive.ts